import * as ReportConstants from 'client/Reports/constants/reportsConstants';
import DateUtil from 'client/util/DateUtil';

export const formatReportsList = (reportsList) => {
  const formattedList = reportsList.map(report => {
    const tempReport = report;
    const hasFilters = report.parameters
      && report.parameters.filters && report.parameters.filters.length > 0;

    tempReport.created_at = DateUtil.formatDateTime(report.created_at);
    tempReport.expiration = DateUtil.formatDateTime(report.expiration);
    tempReport.updated_at = DateUtil.formatDateTime(report.updated_at);
    tempReport.parameters = hasFilters ? report.parameters.filters.join(', ') : '-';
    tempReport.requester_email = report.requester_email || '-';
    tempReport.type = ReportConstants.ReportTypeConsts[report.type];

    return tempReport;
  });

  return formattedList;
};

export default {
  formatReportsList,
};
